module.exports = __webpack_public_path__ + "static/media/PALOSANTO_05.0f02be32.png";